import { render, staticRenderFns } from "./PeriodsTab.vue?vue&type=template&id=7927a403&scoped=true&"
import script from "./PeriodsTab.vue?vue&type=script&lang=js&"
export * from "./PeriodsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7927a403",
  null
  
)

export default component.exports